import { isArray } from 'lodash';



const defaultPermissions = {
	accounting: false,
	setBPSalesPerson: false,
	setOrderSalesPerson: false,
	setBPPaymentTerms: false,
	setBPPriceList: false,
	globalService: false,
	broadcast: false,
};


const groups = {
	accounting: {
		accounting: true,
		setBPSalesPerson: true,
		setOrderSalesPerson: true,
		setBPPaymentTerms: true,
		setBPPriceList: true,
	},
	manager: {
		accounting: true,
		setBPSalesPerson: true,
		setOrderSalesPerson: true,
		setBPPaymentTerms: true,
		setBPPriceList: true,
	},
	admin: {
		accounting: true,
		setBPSalesPerson: true,
		setOrderSalesPerson: true,
		setBPPaymentTerms: true,
		setBPPriceList: true,
		broadcast: true,
	},
	distributor: {
		setBPPaymentTerms: true,
		setBPPriceList: true,
	},
	csr: {
		setBPPriceList: true,
	},
	sales: {},
	debug: {
		globalService: true,
		broadcast: true,
	},
};


export default function getPermissions( permissions ) {
	let effective = { ...defaultPermissions };

	if ( !isArray( permissions ) ) permissions = [ permissions ];

	for (let i = 0; i < permissions.length; i++) {
		try {
			effective = { ...effective, ...(groups[ permissions[ i ] ] || {}) };
		} catch (err) {
		}
	}

	return effective;
}